/* eslint semi: 1 */
import { PageResponse } from '../player-setup-communication';

export const PLAYER_ARRANGEMENTS = {
  horizontal: 'horizontal',
  vertical: 'vertical',
  x2x2: '2x2'
};

export const PLAYER_ARRANGEMENT_OPTIONS = {

  vertial_vertical_x2: { label: 'VERTICAL DISPLAY, VERTICAL ARRANGEMENT x2', orientation: 'vertical', arrangement: PLAYER_ARRANGEMENTS.vertical, outputs: 2 },
  vertial_horizontal_x2: { label: 'VERTICAL DISPLAY, HORIZONTAL ARRANGEMENT x2', orientation: 'vertical', arrangement: PLAYER_ARRANGEMENTS.horizontal, outputs: 2 },

  vertial_vertical_x3: { label: 'VERTICAL DISPLAY, VERTICAL ARRANGEMENT x3', orientation: 'vertical', arrangement: PLAYER_ARRANGEMENTS.vertical, outputs: 3 },
  vertial_horizontal_x3: { label: 'VERTICAL DISPLAY, HORIZONTAL ARRANGEMENT x3', orientation: 'vertical', arrangement: PLAYER_ARRANGEMENTS.horizontal, outputs: 3 },

  vertial_vertical_x4: { label: 'VERTICAL DISPLAY, VERTICAL ARRANGEMENT x4', orientation: 'vertical', arrangement: PLAYER_ARRANGEMENTS.vertical, outputs: 4 },
  vertial_horizontal_x4: { label: 'VERTICAL DISPLAY, HORIZONTAL ARRANGEMENT x4', orientation: 'vertical', arrangement: PLAYER_ARRANGEMENTS.horizontal, outputs: 4 },

  horizontal_vertical_x2: { label: 'HORIZONTAL DISPLAY, VERTICAL ARRANGEMENT x2', orientation: 'horizontal', arrangement: PLAYER_ARRANGEMENTS.vertical, outputs: 2 },
  horizontal_horizontal_x2: { label: 'HORIZONTAL DISPLAY, HORIZONTAL ARRANGEMENT x2', orientation: 'horizontal', arrangement: PLAYER_ARRANGEMENTS.horizontal, outputs: 2 },

  horizontal_vertical_x3: { label: 'HORIZONTAL DISPLAY, VERTICAL ARRANGEMENT x3', orientation: 'horizontal', arrangement: PLAYER_ARRANGEMENTS.vertical, outputs: 3 },
  horizontal_horizontal_x3: { label: 'HORIZONTAL DISPLAY, HORIZONTAL ARRANGEMENT x3', orientation: 'horizontal', arrangement: PLAYER_ARRANGEMENTS.horizontal, outputs: 3 },

  horizontal_vertical_x4: { label: 'HORIZONTAL DISPLAY, VERTICAL ARRANGEMENT x4', orientation: 'horizontal', arrangement: PLAYER_ARRANGEMENTS.vertical, outputs: 4 },
  horizontal_horizontal_x4: { label: 'HORIZONTAL DISPLAY, HORIZONTAL ARRANGEMENT x4', orientation: 'horizontal', arrangement: PLAYER_ARRANGEMENTS.horizontal, outputs: 4 },

  vertial_x2x2: { label: 'VERTICAL 2x2', orientation: 'vertical', outputs: 4 },
  horizontal_x2x2: { label: 'HORIZONTAL 2x2', orientation: 'horizontal', outputs: 4 }
};

export default {
  name: 'player-setup-arrangement',
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    nextPage: {
      type: [String, Object, null],
      default: null
    },
    arrangement: {
      type: [String, null],
      default: null
    },
    outputs: {
      type: Number,
      default: 2
    },
    orientation: {
      type: String,
      default: 'horizontal'
    }
  },
  data () {
    return {
      model: {
        arrangement: ''
      }
    };
  },
  watch: {
    arrangement: {
      immediate: true,
      handler (nVal, oVal) {
        if (nVal && nVal !== oVal) {
          this.model.arrangement = nVal;
        }
      }
    },
    orientation: {
      immediate: true,
      handler (nVal, oVal) {
        if (nVal !== oVal) {
          this.model.arrangement = this.getDefaultArrangement();
        }
      }
    },
    outputs: {
      immediate: true,
      handler (nVal, oVal) {
        if (nVal !== oVal) {
          this.model.arrangement = this.getDefaultArrangement();
        }
      }
    }
  },
  computed: {
    outputsRange () {
      return [...Array(this.outputs - 1)].map((_, i) => i);
    },
    arrangements () {
      return PLAYER_ARRANGEMENTS;
    }
  },
  methods: {
    getDefaultArrangement () {
      return Object.keys(PLAYER_ARRANGEMENT_OPTIONS).find(
        arrangementKey => {
          // For either 'rotateLeft' and 'rotateRight', use 'vertical' for arrangementOrientation
          const arrangementOrientation = this.orientation !== PLAYER_ARRANGEMENTS.horizontal ? PLAYER_ARRANGEMENTS.vertical : this.orientation;

          return PLAYER_ARRANGEMENT_OPTIONS[arrangementKey].orientation === arrangementOrientation && PLAYER_ARRANGEMENT_OPTIONS[arrangementKey].outputs === this.outputs;
        }
      );
    },
    getArrangement (orientation, outputs, arrangement) {
      return Object.keys(PLAYER_ARRANGEMENT_OPTIONS).find(
        arrangementKey => (
          PLAYER_ARRANGEMENT_OPTIONS[arrangementKey].orientation === orientation &&
          PLAYER_ARRANGEMENT_OPTIONS[arrangementKey].outputs === outputs &&
          PLAYER_ARRANGEMENT_OPTIONS[arrangementKey].arrangement === arrangement
        )
      );
    },
    async submitForm () {
      return PageResponse(false, this.nextPage, {
        arrangement: this.model.arrangement
      });
    },
    async triggerFormSubmit (event) {
      this.$emit('SubmitForm');
      return false;
    }
  }
};
